<template>
  <!-- <v-app class="h-auto"> -->
  <v-container class="h-100 container-contact">
    <v-row class="fill-height" justify="center" align="center" v-if="!mobile">
      <div class="contactReqTSA-card">
        <div class="justify-center">
          <v-row class="fill-height px-5" justify="center">
            <v-col class="col-12 col-md-5" align="center" align-content="center" justify="center">
              <div class="title-contactReqTSA mt-5">ติดต่อเพื่อขอใช้บริการ TSA</div><br/>
              <requestService/>
            </v-col>
            <v-col class="col-12 col-md-2" align="center" align-content="center" justify="center" v-if="!mobile">
              <v-divider class="align-center justify-center" dark style="border: 1px solid rgba(0, 0, 0, 0.12);" vertical></v-divider>
            </v-col>
            <v-col class="col-12 col-md-5" align="center" align-content="center" justify="center" v-if="!mobile">
              <div class="title-contactReqTSA mt-5">ติดต่อเรา</div><br/>
              <about/>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-row>
    <v-row justify="center" v-else>
      <div class="contactReqTSA-card">
        <div class="justify-center">
          <template>
            <v-tabs color="#4caf50" v-model="tab" align-with-title centered fixed-tabs>
              <!-- <v-tabs-slider color="#4caf50"></v-tabs-slider> -->
              <v-tab>ขอใช้บริการ TSA</v-tab>
              <v-tab>ติดต่อเรา</v-tab>
            </v-tabs><br/>
            <v-tabs-items v-model="tab">
              <v-tab-item class="h-100">
                <requestService/>
              </v-tab-item>
              <v-tab-item class="h-100">
                <about/>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </div>
      </div>
    </v-row>
  </v-container>
  <!-- </v-app> -->
</template>

<script>
import requestService from '@/components/dashboardTSA/component/contact/requestService.vue'
import about from '@/components/dashboardTSA/component/contact/about.vue'
export default {
  components: {
    requestService,
    about
  },
  data () {
    return {
      tab: null,
      mobile: window.innerWidth <= 959
    }
  },
  created () {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 959
    })
  },
  mounted () {
    this.username = localStorage.getItem('username')
  },
  methods: {
  }
}
</script>

<style scoped>
.h-100 {
  height: 100% !important;
}
.container-contact {
  width: 100% !important;
  overflow: auto;
  max-width: 100%;
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background: url("../../assets/bg-home2.jpg") no-repeat; */
  background-size: cover;
  background-blend-mode: soft-light;
  /* padding-bottom: 0px; */
  padding: 2rem;
  padding-top: 70px;
}
.contactReqTSA-card {
  /* border: 1px solid rgba(0, 0, 0, 0.12); */
  border-radius: 4px;
  min-width: 1000px;
  transition: all 0.5s;
  padding: 10px 40px;
  background: #fff;
  position: relative;
}
.relativeMake {
  position: relative;
  width: 100%;
}
.logo {
  text-align: center;
}
.title-contactReqTSA-header {
  margin: 10px 0;
  font-size: 16px;
  /* color: rgb(126, 126, 126); */
}
.title-contactReqTSA {
  font-size: 16px;
  font-weight: 500;
  color: rgb(77, 77, 77);
}

img.responsive {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 959px) {
  .contactReqTSA-card {
    /* border: 1px solid rgba(0, 0, 0, 0.12); */
    border-radius: 4px;
    min-width: 100% !important;
    transition: all 0.5s;
    padding: 0px !important;
    background: #fff;
    position: relative;
  }
}
</style>
